
const GameColors = {
    Primary: {
        PlayerOne: "Blue",
        PlayerTwo: "Red",
        PlayerThree: "Green",
        PlayerFour: "Yellow"
    },
    Background: { //get muted background color
        PlayerOne: "#ADD8E6",
        PlayerTwo: "#FF474C",
        PlayerThree: "#90EE90",
        PlayerFour: "#FFFFC5"
    },
    TextUnfocused: {
        PlayerOne: "White",
        PlayerTwo: "White",
        PlayerThree: "White",
        PlayerFour: "Black"
    },
    TextFocused: {
        PlayerOne: "Blue",
        PlayerTwo: "Red",
        PlayerThree: "Green",
        PlayerFour: "#8B8000"
    },
    TechnologyColors: {
        Production:"#735334",
        Farm:"#735334",
        Mine:"#735334",

        Urban:"grey",
        Lab:"grey",
        Temple:"grey",
        Library:"grey",
        Arena:"grey",
        Theater:"grey",

        Military:"red",
        Infantry:"red",
        Cavalry:"red",
        Artillery:"red",
        AirForces:"red",

        Government:"#f38f24",
        Special:"#6780c4",
    },
    TechnologyBackgroundColors: {
        Production:"#f4ebc5",
        Farm:"#f4ebc5",
        Mine:"#f4ebc5",

        Urban:"#eeebeb",
        Lab:"#eeebeb",
        Temple:"#eeebeb",
        Library:"#eeebeb",
        Arena:"#eeebeb",
        Theater:"#eeebeb",

        Military:"#fce1dd",
        Infantry:"#fce1dd",
        Cavalry:"#fce1dd",
        Artillery:"#fce1dd",
        AirForces:"#fce1dd",
    }
}

module.exports = 
{
    GameColors,
}